module.exports = __webpack_public_path__ + "static/media/home-product-two.2b1e0203.png";